import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./home.css";

const Home = () => {
  const [isOpened, setIsOpened] = useState(false);
  const [showCard, setShowCard] = useState(false); // 카드 표시 상태
  const [curation, setCuration] = useState(null);
  const [isMobile, setIsMobile] = useState(false); // 모바일 여부 상태
  const [isNewCard, setIsNewCard] = useState(false); // 새로운 카드 여부 상태
  const [showBook, setShowBook] = useState(false); // 책 UI 표시 상태
  const [isBookOpened, setIsBookOpened] = useState(false); // 책 열린 상태 여부
  const [notices, setNotices] = useState([]); // 책 UI에 보여줄 공지사항
  const [currentNoticeIndex, setCurrentNoticeIndex] = useState(0); // 현재 책 UI에 보여줄 공지사항
  const navigate = useNavigate();

  // 화면 크기 감지
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // 초기 체크
    checkMobile();

    // 리사이즈 이벤트 리스너 추가
    window.addEventListener('resize', checkMobile);

    // 클린업
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  
  useEffect(() => {
    fetch(
      "https://raw.githubusercontent.com/Bonitabueno/0331project/refs/heads/main/instatoons.json"
    )
      .then((res) => res.json())
      .then((data) => {
        const today = new Date().toISOString().split("T")[0];
        const todayData = data.find((item) => item.created_at === today);
        
        if (todayData) {
          setCuration(todayData);
          setIsNewCard(true); // 오늘 날짜의 카드가 있으면 새로운 카드
        } else {
          setCuration(data[data.length - 1]);
          setIsNewCard(false); // 오늘 날짜의 카드가 없으면 기본 상태
        }
      });
  }, []);

  // 책 닫힌 이미지가 나오고 0.5초 후 자동으로 열리게
  useEffect(() => {
    if (showBook) {
      setIsBookOpened(false); // 책 초기 상태 닫힘
      const timer = setTimeout(() => {
        setIsBookOpened(true); // 0.5초 후 열림
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [showBook]);
  
  // 공지사항 관련
  useEffect(() => {
    fetch("https://port-0-working-task-madmcado69392982.sel4.cloudtype.app/notice/post26")
      .then((res) => res.json())
      .then((data) => {
        if (data && data.length > 0) {
          const latest = data[0];
          setNotices([latest]);
          setCurrentNoticeIndex(0);
        }
      });
  }, []);

  // 뒤로가기 시 캐릭터 페이지 건너뛰고 인드토 페이지로 이동
  useEffect(() => {
    const handlePopState = () => {
      navigate("/", { replace: true });
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [navigate]);

  const handleGoBook = () => {
    navigate("/Book");
  };

  const handleClick = () => {
    setIsOpened(true);

    // 봉투 열리고 0.5초 후에 카드 등장
    setTimeout(() => {
      setShowCard(true);
    }, 500);
  };
  
  const handleCloseCard = () => {
    setShowCard(false);
    setIsOpened(false);
  };

  // 지난 큐레이션 버튼 클릭 시
  const handlePastCurationClick = () => {
    setShowCard(false); // 카드 숨기기
    setIsOpened(false);  // 봉투 닫기
    setShowBook(true); // 책 UI 표시
    setIsBookOpened(false); // 처음엔 닫힌 상태
  };

  // 메시지 생성 함수
  const getDisplayMessage = () => {
    if (isMobile) {
      return isNewCard 
        ? "새로운 큐레이션 카드가 도착했어요. 아래 편지를 눌러보세요."
        : "아래 편지를 누르고, 큐레이션 카드를 확인해보세요.";
    } else {
      return isNewCard 
        ? "새로운 큐레이션 카드가 도착했어요. 아래 편지를 확인해보세요."
        : "아래 편지를 클릭하고 큐레이션 카드를 확인해보세요.";
    }
  };

  return (
    <div className="home-container">
      <p>{getDisplayMessage()}</p>

      <img
        src={
          isOpened
            ? "/images/envelope_opened.png"
            : "/images/envelope_closed.png"
        }
        alt="편지봉투"
        className="envelope"
        onClick={handleClick}
        style={{ cursor: "pointer", marginTop: "20px" }}
      />

      {/* 큐레이션 카드 */}
      {showCard && curation && (
        <>
          {isMobile ? (
            <div className="curation-card mobile-card">
              <img
                src="/images/curation_card_mobile.png"
                alt="큐레이션 카드 모바일"
              />
              <div className="curation-text">
                <button className="close-card" onClick={handleCloseCard}>
                  ×
                </button>
                <p className="curation-title">{curation.title}</p>
                <p className="curation-content">{curation.content.join(" ")}</p>
                <p className="curation-footer">
                  발행일: {curation.created_at} |
                  <a href={curation.link} target="_blank" rel="noopener noreferrer">작품보러가기</a>
                </p>
              </div>
            </div>
          ) : (
            <div className="curation-card desktop-card">
              <img
                src="/images/curation_card_white.png"
                alt="큐레이션 카드"
              />
              <div className="curation-text">
                <button className="close-card" onClick={handleCloseCard}>
                  ×
                </button>
                <p className="curation-title">{curation.title}</p>
                <p className="curation-content">{curation.content.join(" ")}</p>
                <p className="curation-footer">
                  발행일: {curation.created_at}{" "}
                  <a
                    href={curation.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    작품보러가기
                  </a>
                </p>
              </div>
            </div>
          )}
        </>
      )}
      
      {/* 책 UI: 닫힌 이미지 공통, 열린 이미지 PC와 모바일 분기 */}
      {showBook && (
        <div className="book-ui" onClick={() => setShowBook(false)}>
          <img 
            src={
              isBookOpened 
                ? (isMobile ? "/images/book_opened_mobile.png" : "/images/book_opened.png")
                : "/images/book_closed.png"
            }
            alt="책 이미지"
            className={isBookOpened ? "opened" : ""}
          />
          {isBookOpened && showBook && notices.length > 0 && (
            <div className="notice-text">
              <p className="notice-title">{notices[currentNoticeIndex].title}</p>
              <p className="notice-content">{notices[currentNoticeIndex].content.join(" ")}</p>
              <p className="notice-footer">
                게시일: {notices[currentNoticeIndex].created_at}
                {notices[currentNoticeIndex].link && (
                  <>
                    {" | "}
                    <a
                      href={notices[currentNoticeIndex].link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      링크
                    </a>
                  </>
                )}
              </p>
            </div>
          )}
        </div>
      )}

      {/* 1번째 플로팅 버튼 */}
      <button className="floating-btn" onClick={handlePastCurationClick}></button>

      {/* 2번째 플로팅 버튼 */}
      <button className="floating-btn-secondary" onClick={handleGoBook}></button>
    </div>
  );
};

export default Home;
